var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.splitUnitCodes(_vm.text), function(code, index) {
      return _c(
        "span",
        {
          key: code,
          class: {
            "unit-code": _vm.isSettled(code, _vm.row.settledUnitCode)
          }
        },
        [
          _vm._v(" " + _vm._s(code) + " "),
          index < _vm.splitUnitCodes(_vm.text).length - 1
            ? _c("span", [_vm._v(" , ")])
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }